export const COUNTER_UPDATE = 'COUNTER_UPDATE'



// WEBPACK FOOTER //
// ./src/store/actions/counter.js